import { userType } from 'utils';
import { BASE_PATH } from 'constants/admin-paths';
import { TENANT_DOMAIN_TYPE_SLUGS } from 'constants/tenant-constants';
import { USER_BASE_PATH } from 'constants/user-paths';

export const getBaseRedirectUrl = ({ tenantData }) => {
  switch (tenantData?.current_domain_type?.slug) {
    case TENANT_DOMAIN_TYPE_SLUGS.ADMIN:
      return BASE_PATH;
    case TENANT_DOMAIN_TYPE_SLUGS.PATIENT:
      return USER_BASE_PATH;
    case TENANT_DOMAIN_TYPE_SLUGS.BOTH:
      return BASE_PATH;
    default:
      return BASE_PATH;
  }
};

export const redirectUrlBasedUserType = ({ tenantData }) => {
  if (userType() === 'admin' && tenantData?.current_domain_type?.slug === TENANT_DOMAIN_TYPE_SLUGS.PATIENT) {
    window.location.replace(USER_BASE_PATH);
  } else if (userType() === 'user' && tenantData?.current_domain_type?.slug === TENANT_DOMAIN_TYPE_SLUGS.ADMIN) {
    window.location.replace(BASE_PATH);
  }
};

export const getTenantSepratedValues = (str = '') => {
  if (!str) return {};

  const object = Object.fromEntries(
    str.split(',')?.map((entry) => {
      const [key, value] = entry.split('=');
      return [key, value];
    }),
  );
  return object;
};
